import { Message } from "@alme/ui-web/types/response";
import { AlightStateType } from "../../types/alight-state";
import { Store } from "redux";
import watch from 'redux-watch';
import { AlightCustomSettingsType } from "../../settings/alight-custom-settings";
import * as actions from './actions/actions';
import reducer from './reducers/index';

export default class MissedChatCounter
{
    _settings: AlightCustomSettingsType;
    _store: Store<AlightStateType> | null = null;
    
    constructor(settings: AlightCustomSettingsType,)
    {
        this._settings = settings;
    }

    initialize(store: Store<AlightStateType>): void
    {
        this._store = store;

        const { Base, processedResponse } = this._settings.stateLocations.Conversation;
        const stateLocation = `${Base}.${processedResponse}`;

        const liveChatMessageWatcher = watch(this._store.getState.bind(this), stateLocation);

        this._store?.subscribe(liveChatMessageWatcher((newVal: Message) => this.countMissedLiveChatMessages(newVal)));
    }

    getReducer() {
        return reducer;
    }

    countMissedLiveChatMessages(message?: Message): void
    {
        const { livechatResponseType } = this._settings.messageConstants;

        if (message?.messageType !== livechatResponseType) { return; }

        let state = this._store?.getState();

        if(state){
            let minimized = state.Window.IsMinimized; 

            if(minimized){
                let missedMessages = state.LiveChat.MinimizedCount;
    
                missedMessages = missedMessages + 1;
    
                this._store?.dispatch(actions.setMissedOperatorMessages({
                    stateLocation: `${this._settings.stateLocations.LiveChat.Base}.${this._settings.stateLocations.LiveChat.MinimizedCount}`,
                    missedMessages: missedMessages,
                }));
            }
        }       
    }
}


// WEBPACK FOOTER //
// ./modules/live-chat-foundation-missed-count/live-chat-foundation-missed-count.ts